export default __webpack_public_path__ + "static/il-edit-policy-9670e45e9481f082444bba39e8d0e355.png";